<script setup lang="ts">
defineProps<{ loading?: boolean; error?: string; empty?: boolean; emptyText?: string }>();
</script>

<template>
  <!-- 1.1.150（用户口径 2026-10-26）：「这个正在加载数据样式有点丑，加一个转圈标注，并且后面带稍等一会」
       原来是「18px 小圈 + 一行小字」平铺在 270px 空白里，像占位文本。
       现在：细弧线转圈（34px，带白色内芯）+ 主文案 + 一行浅灰副文案，居中成一张"加载卡" ✓ -->
  <div v-if="loading" class="state-panel lp-wrap" role="status" aria-live="polite">
    <span class="lp-ring" aria-hidden="true"><i /></span>
    <div class="lp-text">
      <b>正在加载数据…</b>
      <small>稍等一会，首次计算可能需要几十秒</small>
    </div>
  </div>
  <div v-else-if="error" class="state-panel error">{{ error }}</div>
  <div v-else-if="empty" class="state-panel">{{ emptyText || '暂无数据' }}</div>
  <slot v-else />
</template>

<style scoped>
.lp-wrap {
  flex-direction: column;
  gap: 14px;
}
/* 细弧线转圈：conic 渐变做"从透明到实色"的尾巴，中间挖白（i）→ 看起来是一条在转的弧线 ✓ */
.lp-ring {
  position: relative;
  display: block;
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background: conic-gradient(
    from 0deg,
    rgba(52, 119, 220, 0) 0deg,
    rgba(52, 119, 220, 0.12) 110deg,
    rgba(52, 119, 220, 0.55) 290deg,
    #3477dc 360deg
  );
  animation: lp-spin 0.9s linear infinite;
}
.lp-ring i {
  position: absolute;
  inset: 5px;
  border-radius: 50%;
  background: #fff;
}
.lp-text {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 3px;
  line-height: 1.4;
}
.lp-text b {
  font-size: 13px;
  font-weight: 600;
  color: #33415c;
  letter-spacing: 0.2px;
}
.lp-text small {
  font-size: 11.5px;
  color: #94a3b8;
}
@keyframes lp-spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
